/**
 * GrowthBook Feature Flag Constants
 *
 * NOTE: This file is auto generated from features.generated.ts by the
 * generate-feature-constants.js utility.
 *
 * Run 'npm run gen:feature-constants' to regenerate.
 *
 * DO NOT EDIT this file manually.
 */

import type { AppFeatures } from "@/types/features.generated";

/**
 * Feature flag names as constants to avoid magic strings.
 * Use these with the typed GrowthBook hooks.
 *
 * @example
 * import { FEATURE_FLAGS, useFeatureIsOn } from '@/utils/growthbook';
 *
 * const MyComponent = () => {
 *   const isEnabled = useFeatureIsOn(
 *     FEATURE_FLAGS.myVerySpecialFeature
 *   );
 *   // ...
 * };
 */
export const FEATURE_FLAGS = {
  selfServeCompetencyModal: "self-serve-competency-modal",
  aiBuilder: "ai-builder",
  copyScreener: "copy-screener",
  viewRestoreArchivedScreeners: "view-restore-archived-screeners",
  screenerBuilderLanguageDropdown: "screener-builder-language-dropdown",
  promptTemplateVersion: "prompt-template-version",
  postPublishEdit: "post-publish-edit",
} as const satisfies Record<string, keyof AppFeatures>;

// Type export for convenience
export type FeatureFlagName = keyof AppFeatures;
